module.exports = __webpack_public_path__ + "static/media/0002.4fe5fd2f.jpg";